/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, bool, array, func } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { createUrl } from 'utils/urlHelper';

import {
  UPDATE_JOB_SUCCESS,
  UPDATE_JOB_FAILURE,
  getJob as getJobAction,
  updateJob as updateJobAction,
} from 'actions/job';

import { makeUpdateJobForm } from 'selectors/updateJobForm';

import Form from 'components/Form/Form';
import SpinnerIcon from 'components/SpinnerIcon/SpinnerIcon';
import Title from 'components/Title/Title';
import Button from 'components/Button/Button';

import styles from './job-edit.scss';

/**
 * This is the JobEdit component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class JobEdit extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    match: shape({
      params: shape({
        jobId: string.isRequired, // @TODO: Change to slug?
      }).isRequired,
    }).isRequired,
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    jobForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    history: object.isRequired,
    job: object.isRequired,
    getJob: func.isRequired,
    updateJob: func.isRequired,
  };

  componentDidMount() {
    const {
      auth: { token },
      match: { params },
      job,
      getJob,
    } = this.props;

    // Check if we have the job in cache.
    const loadJob = job.job_id !== params.jobId;

    if (loadJob) {
      getJob(token, params.jobId);
    }
  }

  updateJob = data => {
    const {
      job: { job_id },
      auth: { token },
      history,
      updateJob,
    } = this.props;

    updateJob(token, job_id, data).then(({ type, payload }) => {
      if (type === UPDATE_JOB_SUCCESS) {
        // Go to job page.
        history.push(createUrl('talents'));
      }

      if (type === UPDATE_JOB_FAILURE) {
        console.log('ERROR', payload);
      }
    });
  };

  /**
   * Render CreateJobs.
   *
   * @return {Object}
   */
  render() {
    const {
      job: { loading, title, job_id },
      jobForm,
    } = this.props;

    if (loading) {
      return (
        <section className={styles.wrapper}>
          <div className={styles.spinner}>
            <SpinnerIcon medium />
          </div>
        </section>
      );
    }

    return (
      <section className={styles.wrapper}>
        <div className={styles.container}>
          <header className={styles.header}>
            <Title title={title} />

            <Button
              path={`/account/jobs/view/${job_id}`}
              ghost
              dark
              small
            >
              VIEW PROJECT
            </Button>

          </header>

          <Form {...jobForm} onSubmit={this.updateJob} />
        </div>
      </section>
    );
  }
}

/**
 * Map state from redux store to props.
 */
const makeMapStateToProps = () => {
  const updateJobForm = makeUpdateJobForm();

  const mapStateToProps = (state, props) => {
    return {
      auth: state.auth,
      job: state.job,
      jobForm: updateJobForm(state, props),
    };
  };
  return mapStateToProps;
};

export default withRouter(
  connect(makeMapStateToProps, {
    getJob: getJobAction,
    updateJob: updateJobAction,
  })(JobEdit)
);
